import React, { Component} from 'react';

import Select from './../Select';

const data = [
    {value: 22, label: "系统管理员权限"},
    {value: 23, label: "督导主任权限"},
    {value: 24, label: "督导老师权限"},
    {value: 25, label: "普通教师权限"},
    {value: 27, label: "督导室维护人员权限"},
    {value: 28, label: "二级学院部门评价权限"},
    {value: 29, label: "校领导查询权限"},
    {value: 30, label: "教务处查询权限"},
    {value: 31, label: "维护人员权限"},
    {value: 32, label: "普通学生权限"},
    {value: 33, label: "学信员管理"}
];



const Role = (props) => (
    <Select name="roleId" label="角色" data={data} {...props} ></Select>
);

export default Role;